import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { FileDto } from '@shared/service-proxies/service-proxies';
import downloadjs from 'downloadjs';
import * as mime from 'mime';

const download = require('downloadjs');

@Injectable()
export class FileDownloadService {
    downloadTempFile(file: FileDto) {
        const url =
            AppConsts.remoteServiceBaseUrl +
            '/File/DownloadTempFile?fileType=' +
            file.fileType +
            '&fileToken=' +
            file.fileToken +
            '&fileName=' +
            file.fileName;
        location.href = url; //TODO: This causes reloading of same page in Firefox
    }

    saveFile(fileAsUrl: string | Blob, filename: string, fileNameIncludesExtension: boolean = true) {
        let mimeType = null;
        if (typeof fileAsUrl === 'string') {
            mimeType = this.getMimeType(fileAsUrl);
        } else {
            mimeType = (fileAsUrl as Blob).type;
        }

        // remove dots from filename to avoid issues with multiple extensions
        let cleanFilename = filename;
        if (!fileNameIncludesExtension) {
            cleanFilename = filename.replace(/\.+/g, '-');
            const extension = mime.default.getExtension(mimeType);
            if (extension && extension.length > 0) {
                cleanFilename = `${cleanFilename}.${extension}`;
            }
        } else {
            // downloadjs uses last dot to determine extension, so no need to change anything
        }

        download(fileAsUrl, cleanFilename, mimeType);
    }

    getMimeType(fileAsUrl: string): string {
        if (!fileAsUrl || fileAsUrl.indexOf(':') === -1 || fileAsUrl.indexOf(';') === -1) {
            return 'application/octet-stream';
        }

        return fileAsUrl.substring(fileAsUrl.indexOf(':') + 1, fileAsUrl.indexOf(';'));
    }
}
